/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { seoRetailerAccessControl } from '../access-control/seoAccess.configuration'

const SeoSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SeoSettingsPage" */
      '../pages/seo-settings/SeoSettingsPage'
    )
)

const PageSeoPage = lazy(
  () =>
    import(
      /* webpackChunkName: "PageSeoPage" */
      '../pages/page-seo/PageSeoPage'
    )
)

const RedirectsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RedirectsPage" */
      '../pages/redirects/RedirectsPage'
    )
)

const SeoScopeWrapper = lazy(() =>
  import('../components/SeoScopeWrapper').then(m => ({
    default: m.SeoScopeWrapper,
  }))
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// The outer `seo` route is partner + site scoped and warehouse-less (its URL
// carries `/sites/:storeConfigId` but no `/warehouses/:warehouse_id`; see routes.ts). Its <Route> puts
// `storeConfigId` into the router match, which the child route's scope wrapper reads via useParams.
// DashRoute renders a route's scope wrapper *above* that route's own <Route>, so the child must stay
// nested under this site-scoped parent for the STORE_CONFIG picker to resolve the site. Mirrors
// cart-assistant; registered in the domain's `partnerScoped` router bucket.
export const seoPartnerScopedRouter = (
  <DomainRoute route="seo">
    <DashSwitch>
      <DomainRoute
        exact
        route="seo-settings"
        component={SeoSettingsPage as ComponentType<any>}
        accessControl={seoRetailerAccessControl}
        scopePickerComponent={SeoScopeWrapper as ComponentType<any>}
      />
      <DomainRoute
        exact
        route="page-seo"
        component={PageSeoPage as ComponentType<any>}
        accessControl={seoRetailerAccessControl}
        scopePickerComponent={SeoScopeWrapper as ComponentType<any>}
      />
      <DomainRoute
        exact
        route="redirects"
        component={RedirectsPage as ComponentType<any>}
        accessControl={seoRetailerAccessControl}
        scopePickerComponent={SeoScopeWrapper as ComponentType<any>}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
